<template>
	<modal :show.sync="syncModal" footerClasses="d-none">
		<FormReportAccess
			:list-type="isUserRole('Superuser') ? 'company' : 'member'"
			assign-from="report"
			:assign-to="isUserRole('Superuser') ? 'company' : 'member'"
			:company-id="currentUser.company ? currentUser.company.id : null"
			:instance="{
				type: isUserRole('Superuser') ? 'Corporate Admin' : 'Employee',
			}"
			:params="params"
			:selected="selected"
			:commit-submit="false"
			class="form-sm"
		>
			<template #header>
				<h4 class="mb-4">Manage Report Access</h4>
			</template>

			<template #return>
				<base-button
					@click.stop="syncModal = false"
					:disabled="formProcessing"
					type="white"
					size="md"
					class="px-0 font-weight-normal shadow-none"
				>
					Cancel
				</base-button>
			</template>
		</FormReportAccess>

		<template #footer>
			<div class="sr-only"></div>
		</template>
	</modal>
</template>

<script>
import { userMixin } from "@mixins";
import FormReportAccess from "@components/FormReportAccess";

export default {
	name: "report-access-modal",
	components: {
		FormReportAccess,
	},
	inject: ["reportSvc"],
	mixins: [userMixin],
	data() {
		return {
			syncModal: false,
			formProcessing: false,
			selected: [],
		};
	},
	computed: {
		listType() {
			return "Superuser" === this.currentUser.role ? "company" : "member";
		},
		params() {
			return "Superuser" === this.currentUser.role
				? {
						page_size: 1000,
				  }
				: {
						type: "Employee",
						company_id: this.currentUser.company
							? this.currentUser.company.id
							: null,
						page_size: 1000,
				  };
		},
	},
	watch: {
		syncModal: function (val) {
			if (!val) this.$bus.$emit("datatable-unselect-rows");
		},
	},
	mounted() {
		this.$bus.trackEvent("toggle-modal", (payload) => {
			if ("report-access" === payload.key)
				this.syncModal = payload.active;
		});

		this.$bus.trackEvent("datatable-selection-changed", (payload) => {
			this.selected = payload.map((item) => {
				const currentCompanyId = this.currentUser.company 
					? this.currentUser.company.id 
					: null;
				
				const filteredAssignments = item[`${this.listType}_assigned`]
					.filter((ia_item) => {
						if (!ia_item[this.listType]) return false;
						
						if (this.listType === 'member' && !this.isUserRole('Superuser') && currentCompanyId) {
							const member = ia_item[this.listType];
							const memberCompanyId = 
								member.company_id || 
								(member.company && typeof member.company === 'object' 
									? member.company.id 
									: member.company);
							
							if (memberCompanyId === undefined || memberCompanyId === null) {
								return true;
							}
							
							return memberCompanyId === currentCompanyId;
						}
						
						return true;
					});
				
				return {
					id: item.report_id || item.id,
					items: filteredAssignments.map((ia_item) => ia_item[this.listType].id),
					assigned_items: filteredAssignments.map((ia_item) => ia_item.id),
				};
			});
		});

		this.$bus.trackEvent("report-access-form-processing", (payload) => {
			this.formProcessing = payload;
		});

		this.$bus.trackEvent("report-access-unassigned", (payload) => {
			this.reportSvc.reports.results
				.filter((ritem) => {
					return (ritem.report_id || ritem.id) === payload.report_id;
				})
				.forEach(async (ritem) => {
					const iindex = ritem[`${this.listType}_assigned`].findIndex(
						(iitem) => iitem.id === payload.id
					);

					if (0 <= iindex) {
						ritem[`${this.listType}_assigned`].splice(iindex, 1);

						if ("member" !== this.listType)
							await this.reportSvc.update(ritem);
					}
				});
		});

		this.$bus.trackEvent("report-access-assigned", (payload) => {
			if (0 < payload.length)
				payload.forEach((pitem) => {
					this.reportSvc.reports.results
						.filter((ritem) => {
							return (
								(ritem.report_id || ritem.id) ===
								pitem.report.id
							);
						})
						.forEach(async (ritem) => {
							const iindex = ritem[
								`${this.listType}_assigned`
							].findIndex((iitem) => iitem.id === pitem.id);

							if (0 <= iindex) {
								ritem[`${this.listType}_assigned`][iindex][
									this.listType
								] = pitem[this.listType];
							} else {
								ritem[`${this.listType}_assigned`].push({
									id: pitem.id,
									[this.listType]: pitem[this.listType],
									report: pitem.report,
								});
							}

							if ("member" !== this.listType)
								await this.reportSvc.update(ritem);
						});
				});
		});

		this.$bus.trackEvent("report-access-form-success", () => {
			this.syncModal = false;

			this.selected = [];
		});
	},
};
</script>
